import { FC } from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import { ValidateCodeReset } from "./Validation/validate";
import { ResetPassword } from "./reset/reset";

const ResetLayout: FC = () => {
  return (
    <div className="reset-wrapper">
      <div className="content-reset">
        <Outlet />
      </div>
    </div>
  );
};

const ResetPage = () => {
  return (
    <Routes>
      <Route element={<ResetLayout />}>
        <Route path="/" element={<ValidateCodeReset />} />
        <Route path="/reset" element={<ResetPassword />} />
      </Route>
    </Routes>
  );
};

export { ResetPage };
